// extracted by mini-css-extract-plugin
export default {"templateTable":"TemplateTable_templateTable__Mbkkd"};